(function () {
  'use strict';

  function isSearchForm(form) {
    try { return new URL(form.action, window.location.href).pathname.replace(/\/$/, '') === '/search'; }
    catch (error) { return false; }
  }

  function plainTerm(value) {
    return value.replace(/&amp;quot;|&quot;|&#34;/gi, '"').replace(/^title:/i, '').replace(/^"|"$/g, '').replace(/\\"/g, '"').trim();
  }

  function titleQuery(value) {
    var term = plainTerm(value);
    return term ? 'title:"' + term.replace(/\\/g, '\\\\').replace(/"/g, '\\"') + '"' : '';
  }

  function ensureField(form, name, value) {
    var field = Array.from(form.elements).find(function (item) { return item.name === name; });
    if (!field) {
      field = document.createElement('input');
      field.type = 'hidden';
      field.name = name;
      form.appendChild(field);
    }
    field.value = value;
  }

  // Scope the first request so sorting and pagination do not scan unrelated pages.
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || !form.elements || !isSearchForm(form)) return;
    var q = Array.from(form.elements).find(function (item) { return item.name === 'q'; });
    if (!q || !q.value.trim()) return;
    q.value = titleQuery(q.value);
    ensureField(form, 'type', 'product');
    var minimum = Array.from(form.elements).find(function (item) { return item.name === 'filter.v.price.gte'; });
    if (!minimum || !minimum.value || Number(minimum.value) < 1) ensureField(form, 'filter.v.price.gte', '1');
  }, true);

  if (window.location.pathname.replace(/\/$/, '') !== '/search') return;
  var url = new URL(window.location.href);
  var q = url.searchParams.get('q');
  if (!q) return;
  var scoped = titleQuery(q);
  var minimum = url.searchParams.get('filter.v.price.gte');
  if (q !== scoped || url.searchParams.get('type') !== 'product' || !minimum || Number(minimum) < 1) {
    url.searchParams.set('q', scoped);
    url.searchParams.set('type', 'product');
    if (!minimum || Number(minimum) < 1) url.searchParams.set('filter.v.price.gte', '1');
    url.searchParams.delete('view_page');
    window.location.replace(url.toString());
    return;
  }

  Array.from(document.querySelectorAll('form')).filter(isSearchForm).forEach(function (form) {
    Array.from(form.elements).forEach(function (field) {
      if (field.name === 'q' && field.type !== 'hidden') field.value = plainTerm(field.value);
    });
  });
})();
